module.exports = __webpack_public_path__ + "static/media/BillionDollarGirlJacket.bba0019e.jpg";